import { useQRStore, } from "../../../store/qrStore.ts";
import { useMutation, } from "@tanstack/react-query";
import { createQrPaymentMutationFn, IQRPaymentResponse, } from "../../../api";
import { useEffectOnce, } from "../../../utils/hooks";
import { useState, } from "react";
import { useToast, } from "@chakra-ui/react";

export function useQrPaymentMutation() {
  const toast = useToast({ id: "qr-payment-error", },);
  const QRPayload = useQRStore(state => state.QRPayload,);
  const [paymentInfo, setPaymentInfo,] = useState<{
    data: IQRPaymentResponse | null;
    isLoading: boolean;
    isError: boolean;
  }>({
    data: null,
    isLoading: true,
    isError: false,
  },);

  const createPaymentMutation = useMutation({
    mutationFn: () => {
      if (!QRPayload) {
        throw new Error("No QR payload info provided",);
      }
      return createQrPaymentMutationFn({ qrPayload: QRPayload, },);
    },
    onSuccess: (response,) => {
      setPaymentInfo({
        data: response,
        isLoading: false,
        isError: false,
      },);
    },
    onError: () => {
      setPaymentInfo({
        data: null,
        isLoading: false,
        isError: true,
      },);
      if (!toast.isActive("qr-payment-error",)) {
        toast({
          description: "Не удалось создать платеж для проведения оплаты по QR",
        },);
      }
    },
  },);

  useEffectOnce(() => {
    createPaymentMutation.mutate();
  },);

  return { createPaymentMutation, paymentInfo, };
}
